import { useEffect, useState } from "react";
import { Radio, Loader2 } from "lucide-react";
import api from "../../lib/api";

/**
 * Tactical strip rendering today's 2-sentence Sentinel briefing.
 * Cached server-side per-user per-UTC-day — calling this multiple times
 * a day is free after the first call.
 */
export default function SentinelBriefingStrip() {
  const [state, setState] = useState({ loading: true, text: "", err: "" });

  useEffect(() => {
    let alive = true;
    api.get("/me/briefing/today")
      .then((r) => { if (alive) setState({ loading: false, text: r.data?.text || "", err: "" }); })
      .catch((e) => {
        if (!alive) return;
        setState({ loading: false, text: "", err: e?.response?.data?.detail || e.message });
      });
    return () => { alive = false; };
  }, []);

  if (state.loading) {
    return (
      <div className="flat-card border-l-2 border-[var(--cyan)] p-4 flex items-center gap-3" data-testid="briefing-loading">
        <Loader2 size={14} className="animate-spin text-[var(--cyan)]" />
        <span className="font-mono text-[10px] tracking-widest uppercase text-[var(--text-2)]">
          // SENTINEL is drafting your morning briefing…
        </span>
      </div>
    );
  }

  if (state.err) {
    return (
      <div className="flat-card border-l-2 border-[var(--amber)] p-4" data-testid="briefing-error">
        <div className="font-mono text-[10px] tracking-widest uppercase text-[var(--amber)] mb-1">// BRIEFING UNAVAILABLE</div>
        <div className="font-mono text-xs text-[var(--text-2)]">{state.err}</div>
      </div>
    );
  }

  if (!state.text) return null;

  return (
    <div
      className="flat-card border-l-2 border-[var(--cyan)] p-4 flex items-start gap-3"
      data-testid="briefing-strip"
    >
      <Radio size={14} className="text-[var(--cyan)] mt-0.5 flex-shrink-0" strokeWidth={1.5} />
      <div className="min-w-0">
        <div className="font-mono text-[10px] tracking-widest uppercase text-[var(--cyan)] mb-1">
          // SENTINEL_BRIEFING · {new Date().toISOString().slice(0, 10)}
        </div>
        <p className="text-sm text-[var(--text-1)] leading-relaxed">{state.text}</p>
      </div>
    </div>
  );
}
